// frontend/src/modules/public/pages/AbrirEmpresa.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck, FaBuilding } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function AbrirEmpresa() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    nome_completo: '',
    email: '',
    telefone: '',
    cpf_cnpj: '',
    nome_empresa: '',
    atividade: '',
    regime_desejado: 'MEI',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    mensagem: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/leads/abertura`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao enviar solicitação');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a237e 0%, #4a90e2 100%)',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    card: {
      maxWidth: '700px',
      margin: '0 auto',
      background: 'white',
      borderRadius: '16px',
      padding: '40px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#6c757d',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '20px',
      fontSize: '14px'
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#1a237e',
      marginBottom: '10px'
    },
    subtitle: {
      color: '#6c757d',
      marginBottom: '30px',
      fontSize: '14px'
    },
    progressBar: {
      display: 'flex',
      gap: '10px',
      marginBottom: '30px'
    },
    step: {
      flex: 1,
      height: '6px',
      background: '#e9ecef',
      borderRadius: '3px',
      transition: 'background 0.3s'
    },
    stepActive: {
      background: '#4a90e2'
    },
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '500',
      color: '#212529',
      fontSize: '14px'
    },
    input: {
      width: '100%',
      padding: '12px 15px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '14px',
      boxSizing: 'border-box',
      transition: 'border-color 0.2s'
    },
    grid2: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '15px'
    },
    button: {
      width: '100%',
      padding: '15px',
      background: '#28a745',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      marginTop: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    },
    buttonBack: {
      width: '100%',
      padding: '15px',
      background: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      marginTop: '10px'
    },
    error: {
      background: '#ffebee',
      color: '#c62828',
      padding: '15px',
      borderRadius: '8px',
      marginBottom: '20px',
      fontSize: '14px'
    },
    successContainer: {
      textAlign: 'center',
      padding: '60px 20px'
    },
    successIcon: {
      fontSize: '80px',
      marginBottom: '20px'
    },
    successTitle: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#28a745',
      marginBottom: '15px'
    },
    successText: {
      color: '#6c757d',
      marginBottom: '30px',
      fontSize: '16px'
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successContainer}>
            <div style={styles.successIcon}>🎉</div>
            <h2 style={styles.successTitle}>Recebemos sua solicitação!</h2>
            <p style={styles.successText}>
              Entraremos em contato em até 24 horas úteis.
            </p>
            <p style={{ color: '#6c757d', fontSize: '14px' }}>
              Verifique seu email: <strong>{formData.email}</strong>
            </p>
            <button
              style={{ ...styles.button, maxWidth: '300px', margin: '30px auto 0' }}
              onClick={() => navigate('/')}
            >
              Voltar para Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <button style={styles.backButton} onClick={() => navigate('/')}>
          <FaArrowLeft /> Voltar para Home
        </button>

        <h1 style={styles.title}>
          <FaBuilding style={{ marginRight: '10px' }} />
          Abrir Empresa
        </h1>
        <p style={styles.subtitle}>
          Preencha os dados abaixo e entraremos em contato em até 24h.
        </p>

        {/* Barra de Progresso */}
        <div style={styles.progressBar}>
          <div style={{ ...styles.step, ...(step >= 1 ? styles.stepActive : {}) }} />
          <div style={{ ...styles.step, ...(step >= 2 ? styles.stepActive : {}) }} />
          <div style={{ ...styles.step, ...(step >= 3 ? styles.stepActive : {}) }} />
        </div>

        {error && <div style={styles.error}>❌ {error}</div>}

        <form onSubmit={handleSubmit}>
          {/* ETAPA 1: Dados Pessoais */}
          {step === 1 && (
            <>
              <h3 style={{ color: '#1a237e', marginBottom: '20px' }}>📋 Seus Dados</h3>
              
              <div style={styles.formGroup}>
                <label style={styles.label}>Nome Completo *</label>
                <input
                  name="nome_completo"
                  value={formData.nome_completo}
                  onChange={handleChange}
                  required
                  style={styles.input}
                  placeholder="Digite seu nome completo"
                />
              </div>

              <div style={styles.grid2}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={styles.input}
                    placeholder="seu@email.com"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Telefone/WhatsApp</label>
                  <input
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleChange}
                    style={styles.input}
                    placeholder="(11) 99999-9999"
                  />
                </div>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>CPF ou CNPJ</label>
                <input
                  name="cpf_cnpj"
                  value={formData.cpf_cnpj}
                  onChange={handleChange}
                  style={styles.input}
                  placeholder="000.000.000-00"
                />
              </div>

              <button type="button" style={styles.button} onClick={() => setStep(2)}>
                Próximo →
              </button>
            </>
          )}

          {/* ETAPA 2: Dados da Empresa */}
          {step === 2 && (
            <>
              <h3 style={{ color: '#1a237e', marginBottom: '20px' }}>🏢 Dados da Empresa</h3>

              <div style={styles.formGroup}>
                <label style={styles.label}>Nome da Empresa (se já tiver)</label>
                <input
                  name="nome_empresa"
                  value={formData.nome_empresa}
                  onChange={handleChange}
                  style={styles.input}
                  placeholder="Nome da empresa"
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Atividade Principal</label>
                <input
                  name="atividade"
                  value={formData.atividade}
                  onChange={handleChange}
                  style={styles.input}
                  placeholder="Ex: Comércio de roupas, Consultoria, etc."
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Regime Tributário Desejado</label>
                <select
                  name="regime_desejado"
                  value={formData.regime_desejado}
                  onChange={handleChange}
                  style={styles.input}
                >
                  <option value="MEI">MEI</option>
                  <option value="SIMPLES_NACIONAL">Simples Nacional</option>
                  <option value="LUCRO_PRESUMIDO">Lucro Presumido</option>
                  <option value="LUCRO_REAL">Lucro Real</option>
                  <option value="NAO_SEI">Não sei / Preciso de ajuda</option>
                </select>
              </div>

              <button type="button" style={styles.button} onClick={() => setStep(3)}>
                Próximo →
              </button>
              <button type="button" style={styles.buttonBack} onClick={() => setStep(1)}>
                ← Voltar
              </button>
            </>
          )}

          {/* ETAPA 3: Endereço e Mensagem */}
          {step === 3 && (
            <>
              <h3 style={{ color: '#1a237e', marginBottom: '20px' }}>📍 Endereço e Observações</h3>

              <div style={styles.grid2}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>CEP</label>
                  <input
                    name="cep"
                    value={formData.cep}
                    onChange={handleChange}
                    style={styles.input}
                    placeholder="00000-000"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Cidade</label>
                  <input
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleChange}
                    style={styles.input}
                    placeholder="Cidade"
                  />
                </div>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Logradouro</label>
                <input
                  name="logradouro"
                  value={formData.logradouro}
                  onChange={handleChange}
                  style={styles.input}
                  placeholder="Rua, Avenida, etc."
                />
              </div>

              <div style={styles.grid2}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Número</label>
                  <input
                    name="numero"
                    value={formData.numero}
                    onChange={handleChange}
                    style={styles.input}
                    placeholder="Nº"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Estado (UF)</label>
                  <input
                    name="estado"
                    value={formData.estado}
                    onChange={handleChange}
                    style={styles.input}
                    placeholder="SP"
                    maxLength="2"
                  />
                </div>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Mensagem (opcional)</label>
                <textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  rows="4"
                  style={{ ...styles.input, resize: 'vertical' }}
                  placeholder="Alguma informação adicional que queira compartilhar?"
                />
              </div>

              <button type="submit" disabled={loading} style={styles.button}>
                {loading ? '⏳ Enviando...' : <><FaCheck /> Enviar Solicitação</>}
              </button>
              <button type="button" style={styles.buttonBack} onClick={() => setStep(2)}>
                ← Voltar
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default AbrirEmpresa;